import {DEFAULT_SKELETON_ITEMS} from '@github-ui/shared-dashboard-lists/pulls/PullsInboxSection'
import {PullsDashboardInboxSectionSkeleton} from '@github-ui/shared-dashboard-lists/pulls/PullsInboxSectionSkeleton'

import {
  useOptionalPullsDashboardPayload,
  usePullsDashboardSectionCollapsedState,
  usePullsDashboardSectionRowCount,
} from '../contexts/PullsDashboardSurfaceStateContext'
import {useVisibleInboxSections} from '../hooks/use-visible-inbox-sections'

export function PullsDashboardInboxSkeleton() {
  const {visibleSections} = useVisibleInboxSections()
  const payload = useOptionalPullsDashboardPayload()
  const collapsedSectionIds = new Set(payload?.collapsedSections)

  return (
    <div data-testid="pulls-dashboard-inbox-skeleton" className="tmp-pt-3">
      <div className="d-flex flex-column gap-4">
        {visibleSections.map(section => (
          <PullsDashboardInboxSectionLoadingState
            key={section.id}
            section={section}
            initiallyCollapsed={collapsedSectionIds.has(section.id)}
          />
        ))}
      </div>
    </div>
  )
}

function PullsDashboardInboxSectionLoadingState({
  section,
  initiallyCollapsed,
}: {
  section: ReturnType<typeof useVisibleInboxSections>['visibleSections'][number]
  initiallyCollapsed: boolean
}) {
  const rememberedRowCount = usePullsDashboardSectionRowCount(section.id)
  const rememberedCollapsedState = usePullsDashboardSectionCollapsedState(section.id)
  const isCollapsed = rememberedCollapsedState ?? initiallyCollapsed
  if (isCollapsed && section.id === 'merge-queue' && !rememberedRowCount) return null

  return (
    <PullsDashboardInboxSectionSkeleton
      name={section.name}
      numItems={isCollapsed ? 0 : (rememberedRowCount ?? Math.min(DEFAULT_SKELETON_ITEMS, section.maxItems))}
    />
  )
}
